import React, { ComponentProps } from 'react';

import Skeleton from '../Base';

const InputSkeleton = (props: ComponentProps<typeof Skeleton>) => (
  <Skeleton height="52px" {...props} />
);

export default InputSkeleton;
